const ProgressMeter = ({ totalProgress }) => {
    const divCount = 20
    const progressStep = 100 / divCount
  
    return (
      <>
        <h2 className="h4 h-style-a">
          <span className="glyphicon glyphicon-stats"></span> mameter
          <span className="fr total_mamater_area" id="total_mamater">
            {totalProgress}%
          </span>
        </h2>
        <div className="mameter">
          {Array.from({ length: divCount }).map((_, index) => {
            const progressThreshold = (index + 1) * progressStep
            const isChecked = totalProgress >= progressThreshold
            return <div key={index} className={`mameter-line ${isChecked ? "mameter-line check" : ""}`}></div>
          })}
        </div>
      </>
    )
  }
  
  export default ProgressMeter
  
  